import { Component, input, model, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-location-details',
    templateUrl: './location-details.component.html',
    styleUrls: ['./location-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class LocationDetailsComponent {
    readonly line2 = model<string | undefined>();
    readonly isReadOnly = input<boolean | undefined>();
    readonly location = input<any>();
}
